import React, { useEffect }  from 'react'
import { makeStyles, createStyles, Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { productCardData } from '../../utils/constant'
import { useImageTranslation } from 'src/hooks'
import { viewItemList, selectItem } from 'src/utils/trackingCode'
import { Helmet  } from 'react-helmet'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    productItem: {
      width: '50%',
      borderBottom: '1px solid #D1D5DB',
      '&:nth-child(2n-1)': {
        borderRight: '1px solid #D1D5DB',
      },
    },
    swiperSlide: {
      borderRadius: theme.spacing(3),
      width: theme.spacing(33),
    },
    swiperSlideChip: {
      borderRadius: theme.spacing(12.5),
      backgroundColor: '#F3F4F6',
      marginTop: theme.spacing(1.5),
      maxWidth: 166,
      minHeight: 40,
      padding: 9.5,
      paddingLeft: 0,
      paddingRight: 0,
    },
    swiperSlideChiplable: {
      marginLeft: 0,
      marginRight: 0,
      display: 'block',
      // whiteSpace: 'normal',
      overflow: 'visible',
      // wordBreak: 'keep-all',
      paddingLeft: 16,
    },
    productCard: {
      flexShrink: 0,
      width: '90%',
      // width: theme.spacing(21.375),
      // height: theme.spacing(21.375),
      margin: '5%',
    },
    swiperSlideImgBox: {
      textAlign: 'left',
      maxWidth: '100%',
      fontWeight: 600,
      fontSize: 18,
      color: 'black',
      paddingRight: 12,
      lineHeight: '150%',
    },
    chip: {
      margin: theme.spacing(3, 1),
      fontWeight: 400,
      fontSize: 14,
      borderRadius: '50px',
      color: '#111827',
      padding: theme.spacing(1.5),
      background: '#f1f2f5',
    },
    product: {
      cursor: 'pointer',
    },
  }),
)
const Promotion = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()
  const history = useHistory()
  const productCard = productCardData.map((item) => {
    return {
      ...item,
      img: tImage(item.imgmobile, 'webp'),
      name: t(item.name),
    }
  })

  useEffect(()=>{
    viewItemList('product_list', 'Product List', productCard)
  },[])
  return (
    <Box width="100%" margin="0 auto">
      <Helmet>
        <meta name="description" content={t('glossary.product.prodect_list')} />
        <title>{t('seoTitle.productList')}</title>
      </Helmet>
      <Box margin={3} mt={3}>
        <Box fontSize={26} fontWeight={600}>
          {t('glossary.product_list')}
        </Box>
        <Box mt={2} color="#4B5563">
          {t('glossary.product.prodect_list')}
        </Box>
      </Box>
      <Box>
        <Box display="flex" maxWidth="100%" flexWrap="wrap" borderTop="1px solid #D1D5DB">
          {productCard.map((item, index) => (
            <Box
              key="index"
              className={classes.productItem}
              onClick={() => {
                selectItem('product_list', 'Product List', item, index)
                history.push(`/${i18n.language}` + item.path)
              }}
            >
              <Box
                width="100%"
                // maxWidth={195}
              >
                <img className={classes.productCard} src={item.img} alt="product info banner" />
                <Box ml={1.5} position="relative">
                  <Box className={classes.swiperSlideImgBox} mb={1.5}>
                    {item.name}
                  </Box>
                  {item.nameInclude ? (
                    <Box textAlign="left" color="#4B5563" mb={1.3} fontSize={14}>
                      {t('glossary.included_Take2Prophecy')}
                    </Box>
                  ) : (
                    ''
                  )}
                  <Box fontSize={18} fontWeight={600} color="secondary.main" textAlign="left">
                    {item.price}
                  </Box>
                  {/* <Typography className={classes.swiperSlideChipBox}>
                    <Chip
                      classes={{ label: classes.swiperSlideChiplable, root: classes.swiperSlideChip }}
                      label={t('glossary.discount', { field: item.discountprice })}
                    />
                  </Typography> */}
                </Box>
                <Box className={classes.chip} mb={1.5} textAlign={i18n.language === 'en' ? 'left' : 'center'}>
                  {t('glossary.discount', { field: item.discountprice })}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <Box height={128} />
    </Box>
  )
}

export default Promotion
